// extracted by mini-css-extract-plugin
export var numpadContainer = "_r7-1";
export var phoneButton = "_r7-0";